import { render, staticRenderFns } from "./ManualCreateEdit.vue?vue&type=template&id=4075d226&"
import script from "./ManualCreateEdit.vue?vue&type=script&lang=ts&"
export * from "./ManualCreateEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports